export default __webpack_public_path__ + "static/media/Prarie-Gayfeather_L2.c6ca1cf9.png";